<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <sector-type-create-or-update v-model="sectorType" :editing="editing" :errors="errors"></sector-type-create-or-update>
            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="user"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    button-alignment="text-right"
                    search>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SectorTypeApi from '@/api/sector-type'
import SectorTypeCreateOrUpdate from './components/SectorTypeCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        SectorTypeCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            errors:{},
            sectorType:{
                Id:null,
                Name:null
            },
            fields:[
                { name:"Sektör Tipi Adı",key:"Name", thClass:"w-100",tdClass:'text-nowrap',sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit},
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete},
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.sectorType.Id = 0
            this.sectorType.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.sectorType.Id = item.Id
            this.sectorType.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SectorTypeApi.CreateOrUpdate(this.editing,this.sectorType)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        refresh(){
            this.$refs.table.refresh()
        },
        provider(data){
            return SectorTypeApi.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} sektör tipini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SectorTypeApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>